define('responsive-gameday/views/Monitor/ViewModels/InningsViewModel',['require','exports','module','./ViewModelBase','../Events/ViewModelUpdateEvents','extant/extant'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        exists = require("extant/extant"),
        Superclass;

    function InningsViewModel() {
        Superclass.constructor.call(this);
    }

    ViewModelBase.spawn(InningsViewModel).define({
        moldData: function(flavor) {
            var dataPack = null;

            if (exists(this.game, "")) {
                dataPack = { };

                this.dispatchUpdates(UpdateEvents.UPDATE_INNING, dataPack);
            };
        }
    });

    Superclass = InningsViewModel.superclass;

    return InningsViewModel;

});
